export default __webpack_public_path__ + "assets/images/b4db681223bf088e34c810afe15b69fe.svg";